import { render, staticRenderFns } from "./ModalTile.vue?vue&type=template&id=660a4085"
import script from "./ModalTile.vue?vue&type=script&lang=js"
export * from "./ModalTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports